/* eslint-disable */
import { useEffect, useState } from 'react';
import MultiCascaderTree from '@/Components/MultiCascaderTree/MultiCascaderTree';
import { notificationServices } from '@/Services';
import { drillDownBuilders } from './createOrdersDrillDownConfig';

const drillDownCache = {};

export const resetDrillDownCache = () => {
	Object.keys(drillDownCache).forEach((key) => delete drillDownCache[key]);
};

const DrillDownStep = ({ stepCfg, buildContext, onChange }) => {
	const stepKey = stepCfg?.key;
	const builder = drillDownBuilders[stepCfg?.drillDown?.entity];
	const [tree, setTree] = useState(() => drillDownCache[stepKey]?.tree || []);
	const [loading, setLoading] = useState(false);

	useEffect(() => {
		if (!stepKey || !builder) return;
		if (drillDownCache[stepKey]?.tree?.length) return;
		let cancelled = false;
		setLoading(true);
		(async () => {
			try {
				const data = await builder.fetchData(buildContext || {});
				const built = builder.buildTree(data) || [];
				if (cancelled) return;
				drillDownCache[stepKey] = {
					...(drillDownCache[stepKey] || {}),
					tree: built,
				};
				setTree(built);
			} catch (error) {
				console.error('Error building drill-down tree:', error);
				notificationServices.generateNotification({
					type: 'error',
					message: 'Could not load the selection tree. Please retry.',
				});
			} finally {
				if (!cancelled) setLoading(false);
			}
		})();
		return () => {
			cancelled = true;
		};
	}, [stepKey]);

	const collectSelectedLeaves = (nodes, parentSelected = false, acc = [], parent = null) => {
		(nodes || []).forEach((node) => {
			const isSelected = node?.select === 1
				|| (node?.select === 0 && parentSelected);
			if (node?.children?.length > 0) {
				collectSelectedLeaves(
					node.children,
					isSelected && node?.select !== -1,
					acc,
					node
				);
				return;
			}
			if (isSelected) {
				const { children, ...rest } = node;
				acc.push({
					...rest,
					parentId: parent?.id ?? null,
					parentType: parent?.type ?? null,
					parentName: parent?.name ?? null,
				});
			}
		});
		return acc;
	};

	const handleTreeChange = (nextTree) => {
		setTree(nextTree);
		if (!stepKey) return;
		const changes = collectSelectedLeaves(nextTree);
		drillDownCache[stepKey] = {
			...(drillDownCache[stepKey] || {}),
			tree: nextTree,
			changes,
		};
		onChange?.(stepKey, changes);
	};

	return (
		<div className='h-full overflow-auto bg-gray-50/60 px-3 py-3'>
			{loading ? (
				<div className='flex h-full items-center justify-center text-[14px] text-gray-500'>
					Loading selection tree…
				</div>
			) : (
				<div className='rounded-xl border border-gray-200 bg-white p-2 shadow-sm overflow-hidden'>
					<MultiCascaderTree
						inputState={tree}
						setInputState={handleTreeChange}
						widthPercentage={stepCfg?.drillDown?.widthPercentage}
						headers={
							stepCfg?.drillDown?.headers
							|| builder?.headers
							|| []
						}
					/>
				</div>
			)}
		</div>
	);
};

export default DrillDownStep;
